import React, { useState, useRef, useEffect } from "react";
import keplerGlReducer from "kepler.gl/reducers";
import { createStore, combineReducers, applyMiddleware } from "redux";
import { taskMiddleware } from "react-palm/tasks";
import { Provider, useDispatch, useSelector } from "react-redux";
import KeplerGl from "kepler.gl";
import { fetchWithAuth } from "./utils/api";
import { Modal, Box, Grid, Card, CardContent, Typography, IconButton } from "@material-ui/core";
import CryptoJS from 'crypto-js';
import WelcomeModal from "./components/WelcomeModal"; // Import modal
import { 
    FaMapMarkerAlt as LocationOn, 
    FaExclamationTriangle as WarningAmber, 
    FaHashtag as Numbers, 
    FaCalendarCheck as EventAvailable, 
    FaTag as Label, 
    FaPalette as Palette,
    FaInfoCircle as InfoIcon,
    FaTable as TableIcon
  } from "react-icons/fa";
import { CircularProgress } from "@material-ui/core";
import { Link } from "react-router-dom";
import { processGeojson, processCsvData } from 'kepler.gl/processors';
import VideoControls from "./VideoControls";
import icon from './websiteIcon.jpg'; // Your company logo
import DropdownWithCheckboxes from './DropdownWithCheckboxes';
import DropdownWithNestedMenu from './DropdownWithNestedCheckboxes';
import ToggleButton from "./components/ToggleButtonMap";
import dataReducer from "./dataReducer";
import Loader from "./components/Loader";
import VideoModalLoader from "./components/VideoModalLoader";
import { fetchAndProcessInfractionData } from "./helpers/fetchAndProcessTrafficInfractionData";
import { fetchAndProcessWardGeoJSON } from "./helpers/fetchAndProcessWardGeoJSON";
import { fetchAndProcessZoneGeoJSON } from "./helpers/fetchAndProcessZoneGeoJSON";
import { fetchAndProcessMPGeoJSON } from "./helpers/fetchAndProcessMPGeoJSON";
import { fetchAndProcessACGeoJSON } from "./helpers/fetchAndProcessACGeoJSON";
import { fetchAndProcessPoliceGeoJSON } from "./helpers/fetchAndProcessPoliceGeoJSON";
import { fetchAndProcessTrafficPoliceGeoJSON } from "./helpers/fetchAndProcessTrafficPoliceGeoJSON";
import { fetchAndProcessRouteCoverageGeoJSON } from "./helpers/fetchAndProcessRouteCoverageGeoJSON";
import { fetchAndProcessSegmentScoreGeoJSON } from "./helpers/fetchAndProcessSegmentScoreGeoJSON";
import { fetchAndProcessSegmentHeatmapScoreGeoJSON } from "./helpers/fetchAndProcessSegmentHeatmapScoreGeoJSON";
import { fetchAndProcessMunicipalInfractionData } from "./helpers/fetchAndProcessMunicipalInfractionData";
import { fetchAndProcessRoadSignData } from "./helpers/fetchAndProcessRoadSignData";
import { reduxkMiddleware } from "./reduxMiddleware/reduxStoreMiddleware";
import { handleInitialLoadJurisdictionDropDown, handleTrafficDropDown, handleMunicipalDropDown, handleRoadSignDropDown, handleJurisdictionDropDown, handleToggleRouteCoverage, handleToggleSegmentScore, handleToggleSegmentHeatmapScore } from "./helpers/dropdownHandler";
import DropDownLoader from "./components/DropdownLoader";

// Combine the kepler reducer into our store.
const reducers = combineReducers({
  keplerGl: keplerGlReducer,
  data: dataReducer
});

const store = createStore(reducers, {}, applyMiddleware(taskMiddleware, reduxkMiddleware));

export default function Brahmand() {
    return (
        <Provider store={store}>
        {/* A fixed full-screen container */}
        <div
            style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            overflow: "hidden",
            backgroundColor: "#000" // fallback background color
            }}
        >
            <Map />
        </div>
        </Provider>
    );
}

function Map() {
    const dispatch = useDispatch();
    const infractionClicked = useSelector(state => state.data.infractionClicked);
    const toggleOffVideoSection = useSelector(state => state.data.toggleOffVideoSection);
    const trafficInfractionList = useSelector(state => state.data.trafficInfractionList);
    const municipalInfractionList = useSelector(state => state.data.municipalInfractionList);
    const canLoadDropDownBool = useSelector(state => state.data.canLoadDropDownBool);
    const remountWardDropDown = useSelector(state => state.data.remountWardDropDown);
    const showWelcomeModal = useSelector(state => state.data.showWelcomeModal);

    const [layerDataState, setLayerDataState] = useState({
        infraction: null,
        wardGeoJSON: null,
        municipalInfractions: null,
        roadSigns: null,
        zoneGeoJSON: null,
        mpGeoJSON: null,
        acGeoJSON: null,
        policeGeoJSON: null,
        trafficPoliceGeoJSON: null,
        routeCoverageGeoJSON: null,
        segmentScoreGeoJSON: null,
        segmentHeatmapScoreGeoJSON: null
    });

    const [openModal, setOpenModal] = useState(false);
    const [selectedEvidence, setSelectedEvidence] = useState({});
    const [boxX, setBoxX] = useState(0.0);
    const [boxY, setBoxY] = useState(0.0);
    const [boxHeight, setBoxHeight] = useState(0.0);
    const [boxWidth, setBoxWidth] = useState(0.0);
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [isTimeLessThan5, setIsTimeLessThan5] = useState(false);
    const [startTime, setStartTime] = useState(0);
    const [duration, setDuration] = useState(0);
    const [currentOverlays, setCurrentOverlays] = useState([]);
    const videoRef = useRef(null);
    const [cellValues, setCellValues] = useState({});
    const [videoModalLoading, setVideoModalLoading] = useState(false);
    const [openAbout, setOpenAbout] = useState(false);
    const [notPausedVideoOnce, setNotPausedVideoOnce] = useState(true);
    const isLoading = !layerDataState.infraction || !layerDataState.wardGeoJSON || !layerDataState.municipalInfractions || !layerDataState.roadSigns || !layerDataState.mpGeoJSON || !layerDataState.acGeoJSON || !layerDataState.zoneGeoJSON || !layerDataState.policeGeoJSON || !layerDataState.trafficPoliceGeoJSON || !layerDataState.routeCoverageGeoJSON || !layerDataState.segmentScoreGeoJSON || !layerDataState.segmentHeatmapScoreGeoJSON;
    const [trafficInfractionTypeDropDown, setTrafficInfractionTypeDropDown] = useState([]);
    const [municipalInfractionTypeDropDown, setMunicipalInfractionTypeDropDown] = useState([]);
    const [roadSignTypeDropDown, setRoadSignTypeDropDown] = useState([]);
    const [jurisdictionWardDropDown, setJurisdictionWardDropDown] = useState([]);
    const [previousWardDropDownSelected, setPreviousWardDropDownSelected] = useState([]);
    const [showWelcomeModalState, setShowWelcomeModalState] = useState(false);
    const [delayedLoading, setDelayedLoading] = useState(isLoading);
    const [jurisdictionZoneDropDown, setJurisdictionZoneDropDown] = useState([]);
    const [previousZoneDropDownSelected, setPreviousZoneDropDownSelected] = useState([]);
    const [jurisdictionMPDropDown, setJurisdictionMPDropDown] = useState([]);
    const [previousMPDropDownSelected, setPreviousMPDropDownSelected] = useState([]);
    const [jurisdictionACDropDown, setJurisdictionACDropDown] = useState([]);
    const [previousACDropDownSelected, setPreviousACDropDownSelected] = useState([]);
    const [jurisdictionPoliceDropDown, setJurisdictionPoliceDropDown] = useState([]);
    const [previousPoliceDropDownSelected, setPreviousPoliceDropDownSelected] = useState([]);
    const [jurisdictionTrafficPoliceDropDown, setJurisdictionTrafficPoliceDropDown] = useState([]);
    const [previousTrafficPoliceDropDownSelected, setPreviousTrafficPoliceDropDownSelected] = useState([]);
    const [showDropDownLoader, setShowDropDownLoader] = useState(false);

    // Manage dimensions for KeplerGl so that it updates on window resize.
    const [dimensions, setDimensions] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    });

    const endTime = startTime + duration;
    const overlays = [
        {
        x: (boxX * 0.20).toFixed(2),
        y: (boxY * 0.20).toFixed(2),
        height: boxHeight && boxHeight > 0.0 ? (boxHeight * 0.20).toFixed(2) : 0.0,
        width: boxWidth && boxWidth > 0.0 ? (boxWidth * 0.20).toFixed(2) : 0.0,
        startTime: isTimeLessThan5 ? startTime - 0.1 : startTime + 4.4,
        endTime: isTimeLessThan5 ? startTime + 0.3 : startTime + 4.8
        }
    ];
    const slowMoStart = isTimeLessThan5 ? startTime - 0.3 : startTime + 4.2;
    const slowMoEnd = isTimeLessThan5 ? startTime + 0.1 : startTime + 4.6;

    // Field cards on the video modal
    const fields = [
        {
            label: 'Infraction Type',
            value: selectedEvidence['Infraction Type'],
            icon: <WarningAmber />
        },
        {
            label: 'Road Sign Type',
            value: selectedEvidence['Road Sign Type'],
            icon: <WarningAmber />
        },
        {
            label: 'Vehicle Number Plate',
            value: selectedEvidence.cleaned_np,
            icon: <Numbers />
        },
        {
            label: 'Time',
            value: selectedEvidence.time ? selectedEvidence.time + ' IST' : 'Not Available',
            icon: <EventAvailable />
        },
        {
            label: 'Vehicle Details',
            value: `${selectedEvidence.response_bodyresultvehiclemanufacturername}`.split(" ")[0]+` ,${selectedEvidence.response_bodyresultmodel}`.slice(0, 12) + "...",
            icon: <Label />
        },
        {
            label: 'Vehicle Colour',
            value: selectedEvidence.response_bodyresultvehiclecolour,
            icon: <Palette />
        },
        {
        label: 'Location',
        value: (
            <div
            onClick={() => {
                handleLoadValueClick(
                selectedEvidence.latitude,
                selectedEvidence.longitude,
                `${selectedEvidence.latitude}_${selectedEvidence.longitude}`
                );
                handleCopyObjectId(selectedEvidence.object_id);
            }}
            style={{ cursor: 'pointer' }}
            >
            {cellValues[`${selectedEvidence.latitude}_${selectedEvidence.longitude}`] ===
            'loading' ? (
                <CircularProgress size={20} />
            ) : cellValues[`${selectedEvidence.latitude}_${selectedEvidence.longitude}`] ? (
                <a
                href={`https://maps.google.com/?q=${selectedEvidence.latitude},${selectedEvidence.longitude}`}
                target="_blank"
                rel="noopener noreferrer"
                >
                {cellValues[`${selectedEvidence.latitude}_${selectedEvidence.longitude}`]}
                </a>
            ) : (
                <span>
                Click to load<i className="reload-icon" />
                </span>
            )}
            </div>
        ),
        icon: <LocationOn />
        }
    ];

    // On "Verify" => load video
    const handleVerifyClick = async (evidence) => {
      try {
        const response = await fetchWithAuth('https://be-lb.chitragupta.co/get-infraction', {
          method: 'POST',
          body: JSON.stringify({
            object_Id: evidence.object_id
          })
        });
        const result = await response.json();
  
        const signedS3Url = decrypt(result.encryptedUrl);
        setSelectedEvidence(evidence);
        setBoxX(result.x);
        setBoxY(result.y);
        setBoxHeight(result.height);
        setBoxWidth(result.width);

        // Temp (TODO) : We've stored our video files in S3 but for temporarily,
        // we're going to get this from physicaly server machine (saved the video files in same folder path structure)
        // Sample new URL : https://vitaraka.chitragupta.co/videos/BLR_Pilot/mishrabikkey57%40gmail.com/Acchu/07-Jun-2024/H1624_1717757645.mp4
        // Sample old URL : signed s3 URL

        const vitarakaUrl = "https://vitaraka.chitragupta.co/videos/" + decodeURIComponent(new URL(signedS3Url).pathname.substring(1));

        // console.log(vitarakaUrl);
        
        setSelectedVideo(vitarakaUrl);
        // setSelectedVideo(signedS3Url);
  
        if (result.startTime === 0) {
          setStartTime(evidence.frame / 30);
          setIsTimeLessThan5(true);
        } else {
          setStartTime(result.startTime);
          setIsTimeLessThan5(false);
        }
        setDuration(6);
        setNotPausedVideoOnce(true);
        setVideoModalLoading(false);
        setOpenModal(true);
      } catch (err) {
        console.error('Error fetching video:', err);
      }
    };

    const decrypt = (encryptedText) => {
        try {
            const parts = encryptedText.split(':');
            const iv = CryptoJS.enc.Hex.parse(parts[0]);
            const encrypted = CryptoJS.enc.Hex.parse(parts[1]);
            const key = CryptoJS.enc.Utf8.parse('12345678901234567890123456789201');

            const decrypted = CryptoJS.AES.decrypt(
            { ciphertext: encrypted },
            key,
            { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
            );
            const base64Decoded = CryptoJS.enc.Utf8.stringify(decrypted);
            return atob(base64Decoded);
        } catch (err) {
            console.error('Decrypt error:', err);
            return '';
        }
    };

    // Close modals
    const handleCloseModal = () => {
        setOpenModal(false);
        setSelectedVideo(null);
        setSelectedEvidence({});
        setCurrentOverlays([]);
    };

      // Video logic
    const handleLoadedMetadata = () => {
        if (videoRef.current) {
        videoRef.current.currentTime = isTimeLessThan5 ? 0 : startTime;
        videoRef.current.play();
        }
    };

    const handleVideoTimeUpdate = () => {
        const video = videoRef.current;
        if (video && video.currentTime >= endTime && notPausedVideoOnce) {
          video.pause();
          setNotPausedVideoOnce(false);
        }
    
        // Show overlays
        const visibleOverlays = overlays.filter(
          (overlay) =>
            overlay.startTime <= video.currentTime && overlay.endTime >= video.currentTime
        );
        setCurrentOverlays(visibleOverlays);
    
        // Slow motion
        if (video.currentTime >= slowMoStart && video.currentTime < slowMoEnd) {
          video.playbackRate = 0.1;
        } else {
          video.playbackRate = 1;
        }
    };

      // "Click to load" location
    const handleLoadValueClick = async (lat, long, lat_long) => {
        try {
        setCellValues((prev) => ({ ...prev, [lat_long]: 'loading' }));
        const response = await fetch(
            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${long}&zoom=18&addressdetails=1`
        );
        const result = await response.json();
        setCellValues((prev) => ({
            ...prev,
            [lat_long]: result.display_name.slice(0, 30) + '...'
        }));
        } catch (error) {
        console.error('Error fetching location:', error);
        setCellValues((prev) => ({ ...prev, [lat_long]: 'Error' }));
        }
    };

    const handleCopyObjectId = (object_id) => {
        navigator.clipboard.writeText(object_id)
          .catch((err) => {
            console.error('Failed to copy object_Id: ', err);
          });
      }

    const FieldCard = ({ field }) => {
        const defaultCardStyle = {
          margin: '8px 0',
          borderRadius: '12px',
          background: 'linear-gradient(145deg, #546E7A, #455A64)', // Lighter dark blue-grey gradient
          boxShadow: '3px 3px 8px rgba(0, 0, 0, 0.4), -3px -3px 8px rgba(255, 255, 255, 0.1)',
          transition: 'transform 0.2s ease, box-shadow 0.2s ease',
          cursor: 'pointer'
        };
      
        const hoverCardStyle = {
          transform: 'translateY(-3px)',
          boxShadow: '4px 4px 10px rgba(0, 0, 0, 0.5), -4px -4px 10px rgba(255, 255, 255, 0.15)'
        };
      
        return (
          <Card
            style={defaultCardStyle}
            onMouseEnter={(e) => {
              Object.assign(e.currentTarget.style, hoverCardStyle);
            }}
            onMouseLeave={(e) => {
              Object.assign(e.currentTarget.style, {
                transform: 'translateY(0)',
                boxShadow: defaultCardStyle.boxShadow
              });
            }}
          >
            <CardContent style={{ padding: '16px', backgroundColor: 'transparent' }}>
              <Box display="flex" alignItems="center">
                {field.icon}
                <Typography
                  component="span"
                  sx={{
                    marginLeft: '12px',
                    fontSize: '15px',
                    fontWeight: 'bold', // Field label in bold
                    color: '#FFFFFF', // White for clarity on a dark background
                    fontFamily: "'Roboto', sans-serif",
                    '& a': {
                      color: '#90caf9', // Light blue for hyperlinks
                      textDecoration: 'none',
                      '&:hover': { textDecoration: 'underline' }
                    }
                  }}
                >
                  &nbsp;{field.label}
                </Typography>
              </Box>
              <Typography
                sx={{
                  marginTop: '8px',
                  color: '#EEEEEE', // Slightly off-white for the field value
                  fontSize: '14px',
                  fontWeight: 500,
                  fontFamily: "'Roboto', sans-serif",
                  minHeight: '200px', // Ensures enough space for roughly two lines of text
                  lineHeight: 1.4,
                  '& a': {
                    color: '#90caf9',
                    textDecoration: 'none',
                    '&:hover': { textDecoration: 'underline' }
                  }
                }}
              >
                {field.value}
              </Typography>
            </CardContent>
          </Card>
        );
      };

    useEffect(() => {
    const handleResize = () => {
        setDimensions({
        width: window.innerWidth,
        height: window.innerHeight
        });
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
    }, []);

  // When the middleware dispatches the MY_LAYER_CLICKED action,
  // the Redux state (data.lastLayerClick) updates, and this useEffect
  // calls your component function.
    useEffect(() => {
        if (infractionClicked && infractionClicked.isDoubledClickedOnInfraction) {
        myLayerClickHandler(infractionClicked);
        }
    }, [infractionClicked]);

    useEffect(() => {
        if (toggleOffVideoSection) {
        setOpenModal(false);
        }
    }, [toggleOffVideoSection]);

    useEffect(() => {
        if (showWelcomeModal) {
            const hasVisited = localStorage.getItem("hasVisited");
            if (!hasVisited) {
                setShowWelcomeModalState(true);
                localStorage.setItem("hasVisited", "true"); 
            }
        }
    }, [showWelcomeModal]);

    useEffect(() => {
        fetchAndProcessInfractionData(setLayerDataState, dispatch, store);
        fetchAndProcessMunicipalInfractionData(setLayerDataState, dispatch, store);
        fetchAndProcessRoadSignData(setLayerDataState, dispatch, store);
        fetchAndProcessRouteCoverageGeoJSON(setLayerDataState, dispatch, store);
        fetchAndProcessSegmentScoreGeoJSON(setLayerDataState, dispatch, store);
        fetchAndProcessSegmentHeatmapScoreGeoJSON(setLayerDataState, dispatch, store);
        fetchAndProcessZoneGeoJSON(trafficInfractionList, municipalInfractionList, false, setLayerDataState, dispatch, store);
        fetchAndProcessPoliceGeoJSON(trafficInfractionList, municipalInfractionList, false, setLayerDataState, dispatch, store);
        fetchAndProcessMPGeoJSON(trafficInfractionList, municipalInfractionList, false, setLayerDataState, dispatch, store);
        fetchAndProcessACGeoJSON(trafficInfractionList, municipalInfractionList, false, setLayerDataState, dispatch, store);
        fetchAndProcessTrafficPoliceGeoJSON(trafficInfractionList, municipalInfractionList, false, setLayerDataState, dispatch, store);
    }, []);

    // Updating geoJSON
    useEffect(() => {
        console.log("Sujeet Loading fetchAndProcessWardGeoJSON useEffect", trafficInfractionList, municipalInfractionList);
        fetchAndProcessWardGeoJSON(trafficInfractionList, municipalInfractionList, true, setLayerDataState, dispatch, store);
    }, [trafficInfractionList
        , municipalInfractionList
        ]);

    // This is the function you want to call when a layer is clicked.
    const myLayerClickHandler = evidence => {
        console.log("Current Map Configuration myLayerClickHandler:", store.getState());
        console.log("App's function called with layer click info:", evidence);
        
        setVideoModalLoading(true);
        handleVerifyClick(evidence);
        // Add any custom logic you require here.
    };

    useEffect(() => {
        if (layerDataState.infraction) {
            // console.log("layerDataState.infraction setTrafficInfractionTypeDropDown :", layerDataState.infraction);
            const uniqueValues = [...new Set(layerDataState.infraction.rows.map(item => item[0]))].sort((a, b) => a.localeCompare(b));
            const result = uniqueValues.map((value, index) => ({
                label: value,
                value: value
            }));
            console.log("layerDataState trafficInfractionTypeDropDown :", trafficInfractionTypeDropDown);
            setTrafficInfractionTypeDropDown(result);
        }
    }, [layerDataState.infraction]);

    useEffect(() => {
        if (layerDataState.municipalInfractions) {
            // console.log("layerDataState.municipalInfractions setMunicipalInfractionTypeDropDown :", layerDataState.municipalInfractions);
            const uniqueValues = [...new Set(processCsvData(layerDataState.municipalInfractions).rows.map(item => item[4]))].sort((a, b) => a.localeCompare(b));
            const result = uniqueValues.map((value, index) => ({
                label: value,
                value: value
            }));
            console.log("layerDataState setMunicipalInfractionTypeDropDown :", result);
            setMunicipalInfractionTypeDropDown(result);
        }
    }, [layerDataState.municipalInfractions]);

    useEffect(() => {
        if (layerDataState.roadSigns) {
            // console.log("layerDataState.roadSigns setRoadSignTypeDropDown :", layerDataState.roadSigns);
            const uniqueValues = [...new Set(processCsvData(layerDataState.roadSigns).rows.map(item => item[4]))].sort((a, b) => a.localeCompare(b));
            const result = uniqueValues.map((value, index) => ({
                label: value,
                value: value
            }));
            console.log("layerDataState setRoadSignTypeDropDown :", result);
            setRoadSignTypeDropDown(result);
        }
    }, [layerDataState.roadSigns]);

    useEffect(() => {
        if (layerDataState.wardGeoJSON) {
            // console.log("layerDataState.wardGeoJSON setJurisdictionWardDropDown :", layerDataState.wardGeoJSON);
            const uniqueValues = [...new Set(processGeojson(layerDataState.wardGeoJSON).rows.map(item => `${item[5]} (${item[1]})`))].sort((a, b) => a.localeCompare(b));
            const result = uniqueValues.map((value) => ({
                label: value,
                value: value
            }));
            console.log("layerDataState ward setJurisdictionWardDropDown :", result);
            setJurisdictionWardDropDown(result);
        }
    }, [layerDataState.wardGeoJSON]);

    useEffect(() => {
        if (layerDataState.zoneGeoJSON) {
            // console.log("layerDataState.wardGeoJSON setJurisdictionWardDropDown :", layerDataState.wardGeoJSON);
            const uniqueValues = [...new Set(processGeojson(layerDataState.zoneGeoJSON).rows.map(item => `${item[2]} (${item[1]})`))].sort((a, b) => a.localeCompare(b));
            const result = uniqueValues.map((value) => ({
                label: value,
                value: value
            }));
            console.log("layerDataState zone setJurisdictionWardDropDown :", result);
            setJurisdictionZoneDropDown(result);
        }
    }, [layerDataState.zoneGeoJSON]);

    useEffect(() => {
        if (layerDataState.mpGeoJSON) {
            // console.log("layerDataState.wardGeoJSON setJurisdictionWardDropDown :", layerDataState.wardGeoJSON);
            const uniqueValues = [...new Set(processGeojson(layerDataState.mpGeoJSON).rows.map(item => `${item[4]} (${item[2]})`))].sort((a, b) => a.localeCompare(b));
            const result = uniqueValues.map((value) => ({
                label: value,
                value: value
            }));
            console.log("layerDataState mp setJurisdictionMPDropDown :", result);
            setJurisdictionMPDropDown(result);
        }
    }, [layerDataState.mpGeoJSON]);

    useEffect(() => {
        if (layerDataState.acGeoJSON) {
            // console.log("layerDataState.wardGeoJSON setJurisdictionWardDropDown :", layerDataState.wardGeoJSON);
            const uniqueValues = [...new Set(processGeojson(layerDataState.acGeoJSON).rows.map(item => `${item[6]} (${item[5]})`))].sort((a, b) => a.localeCompare(b));
            const result = uniqueValues.map((value) => ({
                label: value,
                value: value
            }));
            console.log("layerDataState ac setJurisdictionACDropDown :", result);
            setJurisdictionACDropDown(result);
        }
    }, [layerDataState.acGeoJSON]);

    useEffect(() => {
        if (layerDataState.policeGeoJSON) {
            // console.log("layerDataState.wardGeoJSON setJurisdictionWardDropDown :", layerDataState.wardGeoJSON);
            const uniqueValues = [...new Set(processGeojson(layerDataState.policeGeoJSON).rows.map(item => `${item[4].replace(/\n/g, "").trim()} (${item[5].replace(/\n/g, "").trim()})`))].sort((a, b) => a.localeCompare(b));
            const result = uniqueValues.map((value) => ({
                label: value,
                value: value
            }));
            console.log("layerDataState police setJurisdictionACDropDown :", result);
            setJurisdictionPoliceDropDown(result);
        }
    }, [layerDataState.policeGeoJSON]);

    useEffect(() => {
        if (layerDataState.trafficPoliceGeoJSON) {
            // console.log("layerDataState.wardGeoJSON setJurisdictionWardDropDown :", layerDataState.wardGeoJSON);
            const uniqueValues = [...new Set(processGeojson(layerDataState.trafficPoliceGeoJSON).rows.map(item => `${item[3]} (${item[4]})`))].sort((a, b) => a.localeCompare(b));
            const result = uniqueValues.map((value) => ({
                label: value,
                value: value
            }));
            console.log("layerDataState traffic police setJurisdictionACDropDown :", result);
            setJurisdictionTrafficPoliceDropDown(result);
        }
    }, [layerDataState.trafficPoliceGeoJSON]);

    useEffect(() => {
        if (!isLoading) {
            // Delay setting delayedLoading to false by 2 seconds
            const timer = setTimeout(() => {
                setDelayedLoading(false);
            }, 1000);

            return () => clearTimeout(timer); // Cleanup in case isLoading changes quickly
        } else {
            setDelayedLoading(true); // If loading restarts, show loader again immediately
        }
    }, [isLoading]);

    const handleTrafficDropDownButtonApplyClick = (selected) => {
        handleTrafficDropDown(selected, store, setShowDropDownLoader)
    };
    
    const handleMunicipalDropDownButtonApplyClick = (selected) => {
        handleMunicipalDropDown(selected, store, setShowDropDownLoader)
    };

    return (
    <React.Fragment>
        {showWelcomeModalState && <WelcomeModal setShowWelcomeModalState={setShowWelcomeModalState} />}
        <div
            style={{
                position: "absolute",
                top: 20,
                left: 350,  // Adjust as per requirement
                display: "flex",
                gap: "15px",
                zIndex: 999
            }}
        >
            {/* Example Dropdowns */}
            {canLoadDropDownBool && trafficInfractionTypeDropDown && trafficInfractionTypeDropDown.length > 0 && <DropdownWithCheckboxes 
                title="Traffic Infractions"
                icon="https://cdn-icons-png.flaticon.com/128/2570/2570702.png"
                compact={true}
                options={trafficInfractionTypeDropDown}
                onApply={(selected) => handleTrafficDropDownButtonApplyClick(selected)}
                onInitialLoad={(selected) => handleTrafficDropDown(selected, store, setShowDropDownLoader)}
                defaultSelectAll={true}
            />}

            {canLoadDropDownBool && municipalInfractionTypeDropDown && municipalInfractionTypeDropDown.length > 0 && <DropdownWithCheckboxes 
                title="Municipal Infractions"
                icon="https://cdn-icons-png.flaticon.com/128/1290/1290872.png"
                compact={true}
                options={municipalInfractionTypeDropDown}
                onApply={(selected) => handleMunicipalDropDownButtonApplyClick(selected)}
                onInitialLoad={(selected) => handleMunicipalDropDown(selected, store, setShowDropDownLoader)}
                defaultSelectAll={true}
            />}
            {canLoadDropDownBool && roadSignTypeDropDown && roadSignTypeDropDown.length > 0 && <DropdownWithCheckboxes 
                title="Road Signs"
                icon="https://cdn-icons-png.flaticon.com/128/16694/16694437.png"
                compact={true}
                options={roadSignTypeDropDown}
                onApply={(selected) => handleRoadSignDropDown(selected, store)}
                onInitialLoad={(selected) => handleRoadSignDropDown(selected, store)}
            />}
            {canLoadDropDownBool && jurisdictionWardDropDown && jurisdictionWardDropDown.length > 0 && <DropdownWithNestedMenu
                title="Jurisdictions"
                icon="https://cdn-icons-png.flaticon.com/128/16200/16200756.png"
                compact={true}
                key={remountWardDropDown}
                categories={{
                    "BBMP Ward": jurisdictionWardDropDown,
                    "BBMP Zone": jurisdictionZoneDropDown,
                    "Parliamentary Constituency": jurisdictionMPDropDown,
                    "Assembly Constituency": jurisdictionACDropDown,
                    "BLR Police": jurisdictionPoliceDropDown,
                    "BLR Traffic Police": jurisdictionTrafficPoliceDropDown
                }}
                onApply={(selected) => handleJurisdictionDropDown(selected, store, setPreviousWardDropDownSelected, setPreviousZoneDropDownSelected, setPreviousMPDropDownSelected, setPreviousACDropDownSelected, setPreviousPoliceDropDownSelected, setPreviousTrafficPoliceDropDownSelected)}
                onInitialLoad={(selected) => handleInitialLoadJurisdictionDropDown(selected, store, setPreviousWardDropDownSelected, previousWardDropDownSelected, setPreviousZoneDropDownSelected, previousZoneDropDownSelected, setPreviousMPDropDownSelected, previousMPDropDownSelected, setPreviousACDropDownSelected, previousACDropDownSelected, setPreviousPoliceDropDownSelected, previousPoliceDropDownSelected, setPreviousTrafficPoliceDropDownSelected, previousTrafficPoliceDropDownSelected)}
                defaultSelectedOptions={{
                    "BBMP Ward": previousWardDropDownSelected,
                    "BBMP Zone": previousZoneDropDownSelected,
                    "Parliamentary Constituency": previousMPDropDownSelected,
                    "Assembly Constituency": previousACDropDownSelected,
                    "BLR Police": previousPoliceDropDownSelected,
                    "BLR Traffic Police": previousTrafficPoliceDropDownSelected
                }}
            />}
            {canLoadDropDownBool && <ToggleButton 
                title="Route Coverage"
                icon="https://cdn-icons-png.flaticon.com/128/8327/8327326.png"
                compact={true}
                onToggle={(state) => handleToggleRouteCoverage(state, store)}
            />}
            {canLoadDropDownBool && <ToggleButton 
                title="Road Segment Score"
                icon="https://static.thenounproject.com/png/2479138-200.png"
                compact={true}
                onToggle={(state) => handleToggleSegmentScore(state, store)}
            />}
            {canLoadDropDownBool && <ToggleButton 
                title="Road Segment Heatmap Score"
                icon="https://cdn-icons-png.flaticon.com/128/6868/6868909.png"
                compact={true}
                onToggle={(state) => handleToggleSegmentHeatmapScore(state, store)}
            />}
        </div>

        <div
            style={{
                position: "absolute",
                top: 14,
                right: 380,
                display: "flex",
                gap: "10px",
                zIndex: 999
            }}
        >
            {/* About Button */}
            <IconButton onClick={() => setOpenAbout(true)}>
                <InfoIcon size={25}  style={{ color: '#013f82' }} />
            </IconButton>

            {/* Link to Map (Brahmand) */}
            <Link to="/talika">
                <IconButton onClick={() => handleCloseModal()}>
                    <TableIcon size={25}  style={{ color: '#013f82' }} />
                </IconButton>
            </Link>
        </div>

        <div className="octagon">
            <img src={icon} alt="Icon" className="brahmand-header-icon" />
        </div>

       <KeplerGl
            id="evidence"
            mapboxApiAccessToken="pk.eyJ1IjoiY2dlbmdpbmVlcmluZyIsImEiOiJjbTZ1bTlvYTIwOWE3MmtzYXNqcW9lbDB6In0.KgnbQYG6tkWOMAb7_AIhqA"
            width={dimensions.width}
            height={dimensions.height}
        />

        {delayedLoading && (
                <div
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(255, 255, 255, 0.7)", // Semi-transparent background
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 1000
                }}
                >
                    <Loader />
                </div>
            )}

            {/* {!delayedLoading && showDropDownLoader && (
                <div
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.7)", // Semi-transparent background
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 1000
                }}
                >
                    <DropDownLoader />
                </div>
            )} */}

        {videoModalLoading && <VideoModalLoader />}

        {(
            <div
                style={{
                    position: 'fixed', // Stick to the viewport
                    top: '0',
                    left: '0',
                    width: '774px',
                    height: '100vh', // Full viewport height
                    backgroundColor: 'rgba(3, 3, 29, 0.3)', // Even more transparent dark background
                    backdropFilter: 'blur(10px)', // Glassmorphism blur effect
                    WebkitBackdropFilter: 'blur(10px)', // For Safari support
                    border: '1px solid rgba(255, 255, 255, 0.1)', // Subtle border to enhance the glass look
                    padding: '5px',
                    paddingTop: '10px',
                    borderRadius: '12px',
                    outline: 'none',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    overflow: 'auto',
                    transition: 'transform 0.4s ease-out, opacity 0.4s ease-out',
                    transform: openModal ? 'translateX(0)' : 'translateX(-100%)', // Slide in/out from the left
                    opacity: openModal ? 1 : 0, // Fade in/out for a smoother effect
                    zIndex: 1001 // Ensures this div stays on top of other elements
                  }}
            >
                <button className="close-modal-button" onClick={handleCloseModal}>
                    X
                </button>
                {selectedVideo && (
                    <div>
                        <VideoControls />
                        <video
                            ref={videoRef}
                            key={selectedVideo}
                            muted
                            preload="metadata"
                            className="brahmand-watermarked-video"
                            onLoadedMetadata={handleLoadedMetadata}
                            onTimeUpdate={handleVideoTimeUpdate}
                            controls
                            width="768"
                            height="432"
                            disablePictureInPicture
                            controlsList="nofullscreen nodownload noremoteplayback noplaybackrate"
                            onContextMenu={(e) => e.preventDefault()}
                        >
                            <source src={selectedVideo} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                )}
                {currentOverlays.map((overlay, index) => (
                    <div
                        key={index}
                        className={overlay.width > 0.0 && overlay.height > 0.0 ? "overlay rectangle" : "overlay circle"}
                        style={{
                            top: `${overlay.y}px`,
                            left: `${overlay.x}px`,
                            width: overlay.width > 0.0 && overlay.height > 0.0 ? `${overlay.width}px` : "50px",  // Default small circle size
                            height: overlay.width > 0.0 && overlay.height > 0.0 ? `${overlay.height}px` : "50px",
                            borderRadius: overlay.width && overlay.height ? "0" : "50%", // Circle if no width/height
                        }}
                    />
                ))}
                <div className="watermark">Chitragupta.co</div>

                <div className="field-value-section">
                    <Box sx={{ display: 'flex', width: '100%' }}>
                        <Box sx={{ width: '100%' }}>
                            <Grid container className="grid-container" spacing={1}>
                                {fields
                                .filter(field => field.value && !String(field.value).startsWith("undefined"))
                                .map((field, index) => (
                                    <Grid item xs={6} sm={3} md={4} key={index}>
                                        <FieldCard field={field} />
                                    </Grid>
                                ))}
                            </Grid>
                        </Box>
                    </Box>
                </div>
        </div>)}

        {/* ===== ABOUT MODAL ===== */}
        <Modal open={openAbout} onClose={() => setOpenAbout(false)}>
        <div className="about-modal-content">
            <h2>About Karma Infraction Verification Tool</h2>
            <p>This tool is designed to verify infractions via video, image & details.</p>
            <h3>About Chitragupta.co</h3>
            <p>
            Chitragupta is a planetary-scale sensory data company. We observe the world
            through vision, audio & other sensors, and make it useful.
            </p>
            <button
            onClick={() => setOpenAbout(false)}
            className="close-about-modal-button"
            >
            X
            </button>
        </div>
        </Modal>
    </React.Fragment>
  );
}